module.exports = __webpack_public_path__ + "img/active_white_arrow_left.c4f00afd.svg";